/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import React from 'react';

/**
 * MaterialRounded Tune.
 * @export
 */
export const ICON_TUNE = (
  <svg fill="none" height="28" viewBox="0 0 28 28" width="28" xmlns="http://www.w3.org/2000/svg">
    <path
      clipRule="evenodd"
      d="M19.8333 9.33333C19.8333 9.975 19.3083 10.5 18.6667 10.5C18.025 10.5 17.5 9.975 17.5 9.33333V4.66667C17.5 4.025 18.025 3.5 18.6667 3.5C19.3083 3.5 19.8333 4.025 19.8333 4.66667V5.83333H23.3333C23.975 5.83333 24.5 6.35833 24.5 7C24.5 7.64167 23.975 8.16667 23.3333 8.16667H19.8333V9.33333ZM4.66667 8.16667C4.025 8.16667 3.5 7.64167 3.5 7C3.5 6.35833 4.025 5.83333 4.66667 5.83333H15.1667V8.16667H4.66667ZM4.66667 22.1667C4.025 22.1667 3.5 21.6417 3.5 21C3.5 20.3583 4.025 19.8333 4.66667 19.8333H10.5V22.1667H4.66667ZM15.1667 23.3333V22.1667H23.3333C23.975 22.1667 24.5 21.6417 24.5 21C24.5 20.3583 23.975 19.8333 23.3333 19.8333H15.1667V18.6667C15.1667 18.025 14.6417 17.5 14 17.5C13.3583 17.5 12.8333 18.025 12.8333 18.6667V23.3333C12.8333 23.975 13.3583 24.5 14 24.5C14.6417 24.5 15.1667 23.975 15.1667 23.3333ZM8.16667 12.8333V11.6667C8.16667 11.025 8.69167 10.5 9.33333 10.5C9.975 10.5 10.5 11.025 10.5 11.6667V16.3333C10.5 16.975 9.975 17.5 9.33333 17.5C8.69167 17.5 8.16667 16.975 8.16667 16.3333V15.1667H4.66667C4.025 15.1667 3.5 14.6417 3.5 14C3.5 13.3583 4.025 12.8333 4.66667 12.8333H8.16667ZM24.5 14C24.5 13.3583 23.975 12.8333 23.3333 12.8333H12.8333V15.1667H23.3333C23.975 15.1667 24.5 14.6417 24.5 14Z"
      fill="#949494"
      fillRule="evenodd"
    />
  </svg>
);
